import { styled, Table } from '@mui/material';

export const TableStyled = styled(Table)(({ theme }) => ({
    color: theme.palette.text.secondary,
    fontWeight: theme.typography.fontWeightRegular,
    lineHeight: '150%', // Line height as a percentage of font size
    fontSize: theme.typography.customFontSize.large, // 14px

    '& .MuiTableRow-root.MuiTableRow-head .MuiTableCell-root': {
        color: theme.palette.text.primary,
        fontSize: theme.typography.customFontSize.medium, // 16px
        fontWeight: theme.typography.fontWeightSemiBold,
        lineHeight: theme.typography.customFontSize.large,
    },

    '& .MuiTableBody-root .MuiTableCell-root': {
        background: theme.palette.background.paper,
        color: theme.palette.text.primary,
        borderColor: theme.palette.grey[300],
        fontSize: theme.typography.customFontSize.small, // 14px
        fontWeight: theme.typography.fontWeightMedium,
        lineHeight: '150%',
    },
}));
